<template>
  <div v-if="userList != {}" style="
      position: relative;
      background: #f5f5f5;
      display: block;
      <!-- width: 15.18rem; -->
      margin: 0 auto;
    ">
    <!-- <img class="bg_img" src="../../assets/LS4.png" /> -->
    <div style="position: relative; overflow: hidden" class="bg_img">
      <img style="width: 100%; min-height: 100%" :src="userList.backImage
        ? userList.backImage
        : require('../../assets/LS4.png')
        " />
    </div>
    <div class="body" style="z-index: 3">
      <!-- 左侧 -->
      <div class="body_left">
        <div style="position: relative; top: -0.4rem">
          <img class="body_left_img" style="height: 0.8rem; z-index: 5" :src="userList.avatar ? userList.avatar : require('@/assets/logo.png')
            " />
          <div class="body_left_userList">
            <span>{{ userList.nickName }}</span>
            <!-- <img src="../../assets/publick_huiyuan.png" /> -->
            <img v-if="userList.realStatus == 2" src="@/assets/Frame1.png" title="实名认证" @click="CertificationCenter" />

            <img v-if="userList.enterpriseStatus == 2" src="@/assets/Frame2.png" title="企业认证"
              @click="CertificationCenter" />
            <img v-if="userList.unionStatus == 2" src="@/assets/Frame3.png" title="联盟认证" @click="CertificationCenter" />
            <img v-if="userList.daFlag == 1" src="@/assets/Frame4.png" title="创作达人" />
          </div>
          <div style="display: flex; justify-content: center; padding: 0.18rem 0" @click="CertificationCenter">
            <div class="wVC_list_l_T_B_rz" v-if="userList.professionalStatus == 2">
              <img src="@/assets/bvlv_blue.png" />
              标识山西认证{{ userList.profess }}
            </div>
          </div>
          <div class="body_video_left_userMessage">
            <div @click="VermicelliClick">
              <div class="bvlu_number">{{ userList.fansNumber }}</div>
              <div class="bvlu_title">粉丝</div>
            </div>
            <div style="
                border-left: 0.01rem solid #e5e6eb;
                border-right: 0.01rem solid #e5e6eb;
              ">
              <div class="bvlu_number">
                {{ userList.signingNumer / 1 > 0 ? userList.signingNumer : 0 }}
              </div>
              <div class="bvlu_title">签单</div>
            </div>
            <div @click="FollowClick">
              <div class="bvlu_number">
                {{ userList.followNumber / 1 > 0 ? userList.followNumber : 0 }}
              </div>
              <div class="bvlu_title">关注</div>
            </div>
          </div>
          <div class="body_video_left_message_title">
            {{ userList.remark }}
          </div>
          <div class="body_video_left_button" v-if="myMemberIdShow">
            <button class="bvlb_gz cur" @click="attention">
              {{ userList.isFollow ? "取消关注" : "关注" }}
            </button>
            <!-- <button class="bvlb_lxhz cur" @click="Contact(userList.memberId)">
              联系合作
            </button> -->
          </div>
          <div class="body_video_left_location">
            <img src="../../assets/bvlv_zb.png" style="margin-right: 2px; width: 0.16rem; height: 0.16rem" alt=""
              srcset="" />
            {{
              userList.realPAddress && userList.realDAddress
              ? userList.realPAddress + "-" + userList.realDAddress
              : "暂无具体地址"
            }}
          </div>
          <!-- v-if="!myMemberIdShow" -->
          <div class="body_video_left_visit">
            <div class="bvlv_title">最近访问</div>
            <div v-if="wVC_list.length" class="bvlv_imgList">
              <div class="cur" @click="Details(index)" v-for="index in wVC_list" :key="index">
                <img style="width: 0.5rem; height: 0.5rem; border-radius: 50%" :src="index.avatar
                  ? index.avatar
                  : require('../../assets/logo.png')
                  " />
                <span class="bvlv_imgList_title">{{ index.memberName }}</span>
                <span class="bvlv_imgList_time">{{ index.timeTitle }}</span>
              </div>
              <div class="cur" v-if="wVC_list.length > 5">
                <img @click="windowVisit" src="../../assets/bvlv_gd.png" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧 -->
      <div class="body_right" style="width: calc(100% - 3.02rem); margin-left: 0.24rem">
        <div class="body_right_topList">
          <div style="display: flex; justify-content: left; z-index: 5;column-gap: 20px;">
            <div v-for="(item, index) in right_urlList" :key="index" :class="item.checked == true
              ? 'body_right_topList_t cur'
              : 'body_right_topList_f cur'
              " @click="brtListClick(index)">
              {{ item.title }}
              <span style="color: #fff">{{ item.number }}</span>
            </div>
          </div>
          <span class="ghbj" v-if="!myMemberIdShow" @click="modifyCover = true">
            <img src="../../assets/grzy_icon.png" />
            更换背景
          </span>
        </div>
        <!-- 右侧数据展示 -->
        <div style="padding-left: 0.24rem; display: block">
          <!--作品 -->
          <div v-if="typeOne == 0" style="margin-top: 0.2rem">
            <div class="brt_list top_click_list" style="margin-bottom: 0.2rem">
              <div v-for="(item, index) in ru_zuoping" :key="index" @click="ru_zp_click(index)" :class="item.checked == true
                ? 'top_click_listT cur'
                : 'top_click_listF cur'
                ">
                {{ item.title }}
                {{ item.number }}
              </div>
              <!-- 作品对应的组件展示 -->
            </div>
            <div style="width: 100%">
              <el-row :gutter="20" v-if="SC_VIDEO_LIST1.length">
                <el-col :span="8" v-for="index in SC_VIDEO_LIST1" :key="index">
                  <moduleUserWorks @ParticularsOverYse="ParticularsOverYse" @muk_edit="muk_edit" class="SL_CB_list cur"
                    :item="index" @click="DetailsOfWorksClick(index)">
                  </moduleUserWorks>
                </el-col>
              </el-row>
              <img class="zwsj" v-else src="../../assets/zt_zanwushuju.png" />
            </div>
          </div>
          <!-- 素材 -->
          <div v-if="typeOne == 1">
            <div class="top_click_list" style="margin-bottom: 0.2rem">
              <div style="display: flex" class="top_click_list">
                <div v-for="index in ru_sucai" :key="index" @click="ru_sc_click(index)" :class="index.checked == true
                  ? 'top_click_listT cur'
                  : 'top_click_listF cur'
                  ">
                  {{ index.title }}
                  {{ index.number }}
                </div>
              </div>
              <!-- 作品对应的组件展示 -->
              <div v-if="typeTwo_sucai == 'VIDEO'">
                <el-row :gutter="20" v-if="sucai_video_list.length">
                  <el-col :span="8" v-for="index in sucai_video_list" :key="index">
                    <moduleUserProvideMaterialObserver :message="index" style="
                        border-radius: 0.12rem;
                        height: calc(100% - 0.12rem);
                      " class="cur" @click="
                        getDetailPage('/ShadowMaterialVideoParticulars', index)
                        ">
                    </moduleUserProvideMaterialObserver>
                  </el-col>
                </el-row>
                <img class="zwsj" v-else src="../../assets/zt_zanwushuju.png" />
              </div>
              <div v-if="typeTwo_sucai == 'IMAGE'">
                <el-row :gutter="20" v-if="sucai_image_list.length">
                  <el-col :span="8" v-for="index in sucai_image_list" :key="index">
                    <moduleUserProvideImageObserver class="cur" :message="index" style="border-radius: 0.12rem"
                      @click="getDetailPage('/ShadowMaterialVideoImage', index)">
                    </moduleUserProvideImageObserver>
                  </el-col>
                </el-row>
                <img class="zwsj" v-else src="../../assets/zt_zanwushuju.png" />
              </div>
              <div v-if="typeTwo_sucai == 'MUSIC'">
                <el-row :gutter="20" v-if="sucai_music_list.length">
                  <el-col :span="12" v-for="index in sucai_music_list" :key="index">
                    <moduleUserProvideMusicObserver class="cur" :message="index" style="border-radius: 0.12rem"
                      @click="getDetailPage('/ShadowMaterialVideoMusic', index)">
                    </moduleUserProvideMusicObserver>
                  </el-col>
                </el-row>
                <img class="zwsj" v-else src="../../assets/zt_zanwushuju.png" />
              </div>
            </div>
          </div>
          <!-- 搜藏 -->
          <div v-if="typeOne == 2" style="margin-top: 0.2rem">
            <div class="brt_list top_click_list" style="margin-bottom: 0.2rem">
              <div v-for="(item, index) in ru_soucang" :key="index" @click="ru_soucang_click(index)" :class="item.checked == true
                ? 'top_click_listT cur'
                : 'top_click_listF cur'
                ">
                {{ item.title }}
                {{ item.number }}
              </div>
              <!-- 作品对应的组件展示 -->
            </div>
            <div style="width: 100%" v-if="ru_soucang[0].checked">
              <el-row :gutter="20" v-if="sc_sucai_video1.length">
                <el-col :span="8" v-for="(item, index) in sc_sucai_video1" :key="index">
                  <moduleUserWorks @ParticularsOverYse="ParticularsOverYse" class="SL_CB_list cur" :item="item"
                    :CloseQrCode1="CloseQrCode1">
                  </moduleUserWorks>
                </el-col>
              </el-row>
              <img class="zwsj" v-else src="../../assets/zt_zanwushuju.png" />
            </div>
            <div style="width: 100%" v-if="ru_soucang[1].checked">
              <!-- 视频 -->
              <el-row :gutter="20" v-if="sc_sucai_video.length">
                <el-col :span="8" v-for="(item, index) in sc_sucai_video" :key="index">
                  <moduleProvideMaterial :collectIds="collectIds" class="cur"
                    style="margin-bottom: 0.1rem; height: calc(100% - 1.2px)" :message="item">
                  </moduleProvideMaterial>
                </el-col>
              </el-row>
              <img class="zwsj" v-else src="../../assets/zt_zanwushuju.png" />
            </div>
            <div style="width: 100%" v-show="ru_soucang[2].checked">
              <!-- 音乐 -->
              <el-row :gutter="20" v-if="sc_sucai_music.length > 0">
                <el-col :span="12" v-for="(item, index) in sc_sucai_music" :key="index">
                  <moduleProvideMaterialMusic :userList="userList" :collectIds="collectIds" class="cur" :message="item">
                  </moduleProvideMaterialMusic>
                </el-col>
              </el-row>
              <img class="zwsj" v-else src="../../assets/zt_zanwushuju.png" />
            </div>
            <div style="width: 100%" v-if="ru_soucang[3].checked">
              <!-- 图片 -->
              <el-row :gutter="20" v-if="sc_sucai_image.length > 0">
                <el-col :span="8" v-for="(item, index) in sc_sucai_image" :key="index">
                  <moduleProvideMaterialImage class="cur" :message="item">
                  </moduleProvideMaterialImage>
                </el-col>
              </el-row>
              <img class="zwsj" v-else src="../../assets/zt_zanwushuju.png" />
            </div>
          </div>

          <div style="position: absolute; bottom: -0.3rem; width: 100%">
            <el-pagination v-model:current-page="page3.pageNum" v-model:page-size="page3.pageSize"
              @size-change="sizeChange2" @current-change="currentChange2" style="display: flex; justify-content: center"
              background layout="prev, pager, next" :total="page3.total" />
          </div>
        </div>
      </div>
    </div>
    <!-- 访问列表弹窗 -->
    <div v-if="windowVisitChildren" class="accessListPopup">
      <div class="aLP_center">
        <div class="aLP_center_top">
          <div>最近访问</div>
          <img @click="openWindow" src="../../assets/module_share_open.png" />
        </div>
        <!-- 数据 -->
        <div class="wVC_list" v-for="index in wVC_list" :key="index">
          <div class="wVC_list_l">
            <img class="wVC_list_l_userImg" src="../../assets/logo.png" />
            <div class="wVC_list_l_Title">
              <div class="wVC_list_l_T_T">
                <div class="wVC_list_l_T_T_name">{{ index.memberName }}</div>
                <div class="wVC_list_l_T_T_time">5-17</div>
              </div>
              <div class="wVC_list_l_T_B">
                <div class="wVC_list_l_T_B_rz">
                  <img src="../../assets/bvlv_blue.png" />
                  标识山西认证导演
                </div>
                <span class="wVC_list_l_T_B_location">北京</span>
              </div>
            </div>
          </div>
          <div class="wVC_list_r">
            <button class="wVC_list_r_lx cur">联系</button>
            <button class="wVC_list_r_gz cur" @click="attentionList(index)">
              关注
            </button>
          </div>
        </div>
      </div>
      <div style="
          width: 100%;
          dispaly: block;
          position: absolute;
          bottom: 0;
          left: 0;
          padding-top: 0.5rem;
          background: #fff;
          border-radius: 0.12rem;
        ">
        <!-- <el-pagination style="" layout="prev, pager, next" :total="1000" /> -->
        <el-pagination v-model:current-page="page2.pageNum" v-model:page-size="page2.pageSize" @size-change="sizeChange"
          @current-change="currentChange" background layout="prev, pager, next" :total="page2.total" />
      </div>
    </div>
    <!-- 上传封面 -->
    <el-dialog title="更换背景" v-model="modifyCover" align-center width="800px" :close-on-click-modal="false">
      <div style="width: 100%;margin-top: 10px;">
        <!-- style="width: 800px;" -->
        <el-upload class="avatar-uploader" :action="upload_showImage" :show-file-list="false" :on-change="handleChange"
          :on-success="onSuccessImages" :on-remove="handleRemove">
          <div style="position: relative; height: 1.46rem; width: 100%">
            <div class="modifyCoverUpload">上传背景图</div>
            <img v-if="!imageUrl" style="width: 100%; height: 1.46rem; object-fit: cover" src="../../assets/LS4.png" />
            <img v-else :src="imageUrl" class="avatar" style="object-fit: cover" />
          </div>

          <!-- <el-icon v-else class="avatar-uploader-icon">
						<div
							style="width:0.3rem;height: 0.3rem;background:url(data:image/png;base64,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) ;background-size: 100%;background-repeat: no-repeat;">
									
						</div>
					</el-icon> -->
        </el-upload>
      </div>

      <div style="margin: 0.12rem 0 0.2rem">
        <div style="
            color: #86909c;
            text-align: center;
            font-size: 0.12rem;
            margin-bottom: 0.02rem;
          ">
          请上传格式为 JPG、JPEG、PNG 的文件。
        </div>
        <div style="color: #86909c; text-align: center; font-size: 0.12rem">
          文件大小不超过 5M，图片尺寸不小于 1440*370 px。
        </div>
      </div>

      <div class="modifyCoverBnt" @click="submitSaverBg">保存</div>
    </el-dialog>
    <!-- 支付组件 -->
    <el-dialog title="" :show-close="false" v-model="payment" align-center width="4.8rem" :close-on-click-modal="false">
      <div class="zf_body">
        <div class="zf_body_top">
          <span>联系合作</span>
          <img @click="payment = false" class="cur" src="../../assets/module_share_open.png" />
        </div>
        <div class="zf_body_title">支付相应费用，获得联系方式</div>
        <div class="zf_b_M">
          <span CLASS="zf_b_M_title">应付金额：</span>
          <span class="zf_b_M_number"><text class="zf_b_M_n_icon">￥</text>{{ (moenyNumber / 1).toFixed(2) }}</span>
        </div>
        <div class="zf_fs_body">
          <div class="zf_fs_title">选择付款方式</div>
          <div class="zf_fs_list">
            <div v-for="index in paymentTypeList" :key="index" @click="paymentTL_click(index)">
              <img class="zf_fs_logo cur" :src="index.img" />
              <span>{{ index.title }}</span>
              <img v-if="index.checked" class="zf_fs_icon" src="../../assets/lxhz_icon.png" alt="" />
            </div>
          </div>
        </div>
        <div class="zf_fs_b">
          <div class="zf_fs_b_qx cur" @click="payment = false">取消</div>
          <div class="zf_fs_b_qd cur" @click="get_sjh(userList.memberId)">
            确定
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- <el-dialog
      title=""
      :show-close="false"
      v-model="true"
      align-center
      width="4.8rem">
      <div class="zf_body">
        <div class="zf_body_top">
          <span>联系合作</span>
          <img
            @click="payment = false"
            src="../../assets/module_share_open.png"
          />
        </div>
        <div style="color: #86909c; font-size: 14px; margin: 0 auto">
          联系方式
        </div>
        <div style="color: #333333; font-size: 24px; margin: 0 auto">
          1758888888
        </div>
        <div class="zf_fs_b">
          <div class="zf_fs_b_qx" @click="payment = false">取消</div>
          <div class="zf_fs_b_qd" @click="get_sjh(userList.memberId)">确定</div>
        </div>
      </div>
    </el-dialog> -->
    <el-dialog v-model="PartnersMobileNumber" align-center width="480px" :close-on-click-modal="false">
      <div style="text-align: center">联系方式</div>
      <div style="text-align: center; padding-top: 5px; font-size: 20px">
        {{ PartnersMobileNumber1 }}
      </div>
      <div style="display: flex; justify-content: center">
        <div class="dataBtnClose" @click="PartnersMobileNumber = false">
          取消
        </div>
        <div class="dataBtnSubmit" @click="PartnersMobileNumber = false">
          确认
        </div>
      </div>
    </el-dialog>
    <two-dimensional-code ref="TwoDimensionalCodeRef" :CloseQrCode="CloseQrCode" />
    <details-of-works ref="DetailsOfWorksRef" :CloseQrCode="CloseQrCode" />
    <follow ref="FollowRef" />
    <vermicelli ref="VermicelliRef" />
  </div>
</template>

<script setup lang="ts">
import { ref, watch, nextTick } from "vue";
import { useRouter } from "vue-router";
import { Axios } from "../../assets/js/ls_com_axios.js";
import { ElMessage, ElTable, ElLoading } from "element-plus";
import moduleUserProvideMaterialObserver from "../../components/moduleUserProvideMaterialObserver.vue"; // 素材 - 视频
import moduleUserProvideMusicObserver from "../../components/moduleUserProvideMusicObserver.vue"; // 素材 - 音乐
import moduleUserProvideImageObserver from "../../components/moduleUserProvideImageObserver.vue"; // 素材 - 图片
//展示的
import moduleProvideMaterial from "../../components/sc_moduleProvideMaterial.vue";
// import moduleProvideMaterial from "../../components/sc_moduleProvideMaterial.vue";
import moduleProvideMaterialMusic from "../../components/sc_moduleProvideMaterialMusic.vue";
import moduleProvideMaterialImage from "../../components/sc_moduleProvideMaterialImage.vue";
import TwoDimensionalCode from "./components/TwoDimensionalCode.vue";
const TwoDimensionalCodeRef = ref<any>();
import moduleUserWorks from "../../components/moduleUserWorks.vue";
import DetailsOfWorks from "@/views/ShadowUser/components/DetailsOfWorks.vue";
// 关注
import Follow from "@/components/Composer/Follow.vue";
// 粉丝
import Vermicelli from "@/components/Composer/Vermicelli.vue";

document.title = "标识山西-找创作人-创作人详情";
const DetailsOfWorksRef = ref<any>();
const router = useRouter();
const PartnersMobileNumber = ref(false);
const PartnersMobileNumber1 = ref();
const FollowRef = ref();
const VermicelliRef = ref();
//观察者 observer moduleUserProvideImage
const nav_url = ref("/SCH_works");
const urlNumber = ref[0];
// 封面
const modifyCover = ref(false);
import { serverBaseUrl } from "@/assets/js/ls_tgServerUrls.js";
const upload_showImage = ref(serverBaseUrl + "/file/upload");
// 允许的文件类型
const allowedExtensions = [".png", ".jpg", ".jpeg"];
// 图片URL
const imageUrl: any = ref("");
// 上传处理函数
const handleChange = (file: File, fileList: Array<File>) => {
  const extension = file.name.slice(file.name.lastIndexOf("."));

  if (!allowedExtensions.includes(extension.toLocaleLowerCase())) {
    const index = fileList.indexOf(file);
    // 移除非法的文件
    fileList.splice(index, 1);
    // upload.value.handleRemove(file, index);
    // 如果有额外的上传组件的移除方法，写在这里
    return ElMessage.warning("格式不正确");
  }
};

// 上传成功的处理函数
const onSuccessImages = (file) => {
  console.log("file", file);
  imageUrl.value = file.data.url;
};

// 在必要的地方删除了图片
const handleRemove = (file: File, fileList: Array<File>) => {
  const index = fileList.indexOf(file);
  fileList.splice(index, 1);
  imageUrl.value = null;
};
const submitSaverBg = () => {
  console.log(imageUrl.value);
  // console.log(imageUrl, "上传图片后台返回的路径");
  // ElMessage({
  //   message: "开发中。。。",
  //   type: "success",
  // });
  // 1、点击保存执行后台，将imageUrl和其它数据一起传给后台保存。
  //2、保存成功后   modifyCover.value = false;关闭背景上传弹窗，并刷新数据更新背景图片
  Axios(
    "get",
    `/member/setting-back`,
    { path: imageUrl.value },
    false,
    function (res) {
      console.log("=================", res);
      modifyCover.value = false;
      ElMessage.success("上传成功");
      getuserMassage();
    }
  );
};
//跳转关注
const FollowClick = () => {
  FollowRef.value.init(router.currentRoute.value.query.id);
};
const Details = (item) => {
  router.push({
    path: "/ShadowComposerHomepage",
    query: { id: item.memberId },
  });
};
const VermicelliClick = () => {
  VermicelliRef.value.init(JSON.parse(router.currentRoute.value.query.id));
};
//跳转作品详情
const DetailsOfWorksClick = (item) => {
  DetailsOfWorksRef.value.init(item.id);
};
const windowVisitChildren = ref(false);
const windowVisit = function () {
  getBrowse(true);
  windowVisitChildren.value = true;
};
const openWindow = function () {
  windowVisitChildren.value = false;
};
// 获取收藏的素材列表
let sc_sucai_video = ref([]);
let sc_sucai_video1 = ref([]);
let sc_sucai_music = ref([]);
let sc_sucai_image = ref([]);

let get_soucang_sucai_list = function (type) {
  Axios(
    "get",
    "/fodder/collect/list",
    {
      memberId: router.currentRoute.value.query.id,
      materialType: type,
      pageNum: page3.value.pageNum,
      pageSize: page3.value.pageSize,
    },
    false,
    function (res) {
      if (type == "MUSIC") {
        sc_sucai_music.value = res.data.rows;
      }
      if (type == "VIDEO") {
        sc_sucai_video.value = res.data.rows;
      }

      if (type == "IMAGE") {
        sc_sucai_image.value = res.data.rows;
      }
      page3.value.total = res.data.total;
    }
    // function (res) {
    //   console.log(res);
    // }
  );
};
let get_soucang_sucai_list1 = function (type) {
  let id = router.currentRoute.value.query.id;
  Axios(
    "post",
    "/material/material/work/favoriteWork",
    {
      pageIndex: page3.value.pageNum,
      pageSize: page3.value.pageSize,
      condition: {
        userId: id,
      },
    },
    false,
    function (res) {
      sc_sucai_video1.value = res.data.data.records;

      if (type) {
      } else {
        page3.value.total = res.data.data.total;
      }
      ru_soucang.value[0].number = res.data.data.total;
      right_urlList.value[2].number =
        ru_soucang.value[0].number +
        ru_soucang.value[1].number +
        ru_soucang.value[2].number +
        ru_soucang.value[3].number;
    }
  );
};
const CloseQrCode = (e) => {
  payment.value = false;
  Axios(
    "get",
    "/member/contacts/phone/" + e,
    {},
    false,
    function (res) {
      // res;
      PartnersMobileNumber.value = true;
      PartnersMobileNumber1.value = res.data.msg;
      // PartnersMobileNumber1.value = res.data.data.info.partyBContactInfo;
    },
    function (res) { }
  );
};

//接受id
let id = ref("");
let userList = ref({});
// Axios("GET", "/member/info/" + id.value, false, false, function (res) {
//   userList.value = res.data.data;

//   addBrowse();
// });
//获取用户数据
const myMemberIdShow = ref(true);

let getuserMassage = function () {
  Axios("GET", "/member/info/" + id.value, false, false, function (res) {
    console.log(res.data.data);

    userList.value = res.data.data;
    myMemberIdShow.value = true;
    if (
      JSON.parse(localStorage.getItem("userList")).memberId ==
      userList.value.memberId
    ) {
      myMemberIdShow.value = false;
    }
    brtListClick(router.currentRoute.value.query.s ? 1 : 0);
    document.title += userList.value.nickName;
    addBrowse();
  });
};
// getuserMassage();
//关注/取消关注 [当前主页的创作者]
let attention = function () {
  if (userList.value.isFollow == false) {
    Axios(
      "POST",
      "/member/member-follow",
      { memberId: userList.value.memberId },
      false,
      function (res) {
        ElMessage({
          showClose: true,
          message: "关注成功",
          type: "success",
        });
        getuserMassage();
      }
    );
  } else {
    Axios(
      "DELETE",
      "/member/member-follow",
      { memberId: userList.value.memberId },
      false,
      function (res) {
        ElMessage({
          showClose: true,
          message: "已取消关注",
          type: "success",
        });
        getuserMassage();
      }
    );
  }
};
//关注/取消关注 [浏览记录里面的作者列表]**未完成
let attentionList = function (index) {
  return;
};
// 登陆者浏览记录添加
let addBrowse = function () {
  if (localStorage.getItem("token")) {
    Axios(
      "POST",
      "/member/member-visited",
      { memberId: userList.value.memberId },
      false,
      function (res) {
        getBrowse(false);
      }
    );
  } else {
    getBrowse(false);
  }
};
// 支付组件状态
let payment = ref(false);
let PaymentV = ref("");
// 支付类型列表
let paymentTypeList = ref([
  // {
  //   title: "我的账户",
  //   img: require("../../assets/lxhz_pb.png"),
  //   checked: true,
  // },
  {
    title: "微信",
    dh: "wx",
    img: require("../../assets/lxhz_wx.png"),
    checked: false,
  },
  {
    title: "支付宝",
    dh: "zfb",
    img: require("../../assets/lxhz_zfb.png"),
    checked: false,
  },
]);
//支付金额
let moenyNumber = ref(0);
// 支付类型切换
let paymentTL_click = function (index) {
  PaymentV.value = index.dh;
  for (let i = 0; i < paymentTypeList.value.length; i++) {
    if (index == paymentTypeList.value[i]) {
      paymentTypeList.value[i].checked = true;
    } else {
      paymentTypeList.value[i].checked = false;
    }
  }
};

// 获取联系合作 // index 回去对象的的id
let Contact = function (index) {
  Axios(
    "get",
    "/member/contacts/phone/" + index,
    {},
    false,
    function (res) {
      PartnersMobileNumber.value = true;
      PartnersMobileNumber1.value = res.data.msg;
    },
    function (res) {
      ElMessage({
        showClose: true,
        message: res.data.msg,
        type: "warning",
      });
      console.log(res.data.data);

      getMoney();
    }
  );
};
//获取金额
let getMoney = function () {
  Axios("get", "/member/contacts/pay-amount", {}, false, function (res) {
    moenyNumber.value = res.data.msg;
    payment.value = true;
  });
};
// 支付获取联系方式
let get_sjh = function (index) {
  Axios(
    "POST",
    "/member/contacts?memberId=" + index,
    {},
    false,
    function (res) {
      console.log(res.data);
    },
    function (res) {
      let url: any;
      if (PaymentV.value == "wx") {
        url = `/member/contacts/create-order/WXPAY/${index}`;
      } else if (PaymentV.value == "zfb") {
        url = `/member/contacts/create-order/ALIPAY/${index}`;
      }
      Axios(
        "POST",
        url,
        {},
        false,
        function (res) {
          console.log();

          // console.log(res.data.data);
          TwoDimensionalCodeRef.value.init(
            res.data.data.qrcode,
            res.data.data.sceneId,
            index
          );
        },
        function (res) {
          console.log(res.data);
        }
      );
    }
  );
};
//浏览者记录封页列表
// 默认的数据展示
let page1 = ref({
  pageNum: 1, //页数
  total: 0, // 总数
  pageSize: 5,
});
// 弹窗的数据展示
let page2 = ref({
  pageNum: 1, //页数
  total: 0, // 总数
  pageSize: 10,
});
// 获取浏览者记录
let wVC_list = ref([]);
let getBrowse = function (index) {
  // let memberId = JSON.parse(localStorage.getItem("userList")).memberId;
  let params = {
    visitedId: userList.value.memberId,
    pageNum: "",
    pageSize: "",
  };
  // index true 是获取弹窗数据 , false 获取默认数据

  if (index) {
    params.pageNum = page2.value.pageNum;
    params.pageSize = page2.value.pageSize;
  } else {
    params.pageNum = page1.value.pageNum;
    params.pageSize = page1.value.pageSize;
  }
  Axios("GET", "/member/member-visited/list", params, false, function (res) {
    page2.value.total = res.data.total;
    page1.value.total = res.data.total;
    let datas = res.data.rows;
    let DQ_date = new Date().valueOf();
    console.log("DQ_date", DQ_date);
    function computeTimeTitle(data) {
      console.log("data.visiteTime", data.visiteTime);
      let timer = new Date(data.visiteTime).valueOf();
      let zfc = DQ_date - timer;
      console.log("zfc", zfc);
      let f = 60 * 1000; // 1分钟
      let s = 60 * 60 * 1000; // 1小时
      let t = 60 * 60 * 24 * 1000; // 一天

      if (zfc > t) {
        return (
          new Date(data.visiteTime).getMonth() +
          1 +
          "月" +
          new Date(data.visiteTime).getDate() +
          "日"
        );
      } else if (s < zfc && zfc < t) {
        let xiaoshi = Math.floor((DQ_date - timer) / s);
        let fengzhong = Math.floor(((DQ_date - timer) % s) / f);
        return xiaoshi + "小时" + fengzhong + "分钟";
      } else if (f < zfc && zfc < s) {
        let fengzhong = Math.floor((DQ_date - timer) / f);
        return fengzhong + "分钟前";
      } else if (zfc < f) {
        return "刚刚";
      }
    }

    for (let i = 0; i < datas.length; i++) {
      datas[i]["timeTitle"] = computeTimeTitle(datas[i]);
    }

    datas.sort((a, b) => new Date(b.visiteTime) - new Date(a.visiteTime));
    wVC_list.value = datas;
  });
};

const CertificationCenter = (item) => {
  router.push({
    path: "/AuthenTicationHome",
  });
};
const sizeChange = (val) => {
  getBrowse(true);
};
const currentChange = (val) => {
  page2.value.pageNum = val;
  getBrowse(true);
};
const prevClick = (val) => {
  page.value.pageNum = val;
  getBrowse(true);
};
const nextClick = (val) => {
  page.value.pageNum = val;
  getBrowse(true);
};
//****************************************************************************//
//***********************************右侧数据**********************************//
//****************************************************************************//
// 右侧数据展示
const right_urlList = ref([
  {
    title: "案例",
    number: "0",
    checked: true,
  },
  {
    title: "素材",
    number: "0",
    checked: false,
  },
  {
    title: "收藏",
    number: "0",
    checked: false,
  },
]);
//一级状态
const typeOne = ref(0);

const brtListClick = function (index) {
  for (let i = 0; i < right_urlList.value.length; i++) {
    if (i == index) {
      right_urlList.value[i].checked = true;
      typeOne.value = i;
      page3.value.pageNum = 1;
      page3.value.total = 1;
      switch (i) {
        case 0:
          // 作品
          ru_zuoping.value.forEach((e, index) => {
            e.checked = false;
          });
          ru_zp_click(0);
          break;
        case 1:
          // 素材看不懂没写
          break;
        case 2:
          // 收藏
          ru_soucang_click(0);
          break;
        default:
          // 默认情况下的处理逻辑
          break;
      }
      // console.log(page3.value.pageNum);
    } else {
      right_urlList.value[i].checked = false;
    }
  }
  //素材
  if (typeOne.value == 1) {

    ru_sc_click();
  }
};
// 右侧 - 作品
let ru_zuoping = ref([
  {
    title: "默认",
    checked: true,
    number: 0,
  },
  {
    title: "最新作品",
    checked: false,
    number: 0,
  },
  {
    title: "热门作品",
    checked: false,
    number: 0,
  },
]);
let ru_zp_click = function (index) {
  for (let i = 0; i < ru_zuoping.value.length; i++) {
    if (i === index) {
      ru_zuoping.value[i].checked = true;
    } else {
      ru_zuoping.value[i].checked = false;
    }
  }
  page3.value.pageNum = 1;
  getListZUOPING(index);
};

//素材 二级状态
const typeTwo_sucai = ref("");
//右侧 - 素材
let ru_sucai = ref([
  {
    title: "视频素材",
    checked: true,
    number: 0,
    type: "VIDEO",
  },
  {
    title: "音乐素材",
    checked: false,
    number: 0,
    type: "MUSIC",
  },
  {
    title: "图片素材",
    checked: false,
    number: 0,
    type: "IMAGE",
  },
]);
let ru_sc_click = function (index) {
  page3.value.pageNum = 1;
  if (index) {
    for (let i = 0; i < ru_sucai.value.length; i++) {
      if (ru_sucai.value[i] == index) {
        ru_sucai.value[i].checked = true;
        typeTwo_sucai.value = ru_sucai.value[i].type;
        sucai_params.value.materialType = ru_sucai.value[i].type;
        sucai_params.value.memberId = userList.value.memberId;
        get_sucaiList();
      } else {
        ru_sucai.value[i].checked = false;
      }
    }
  } else {
    for (let i = 0; i < ru_sucai.value.length; i++) {
      if (ru_sucai.value[i].checked == true) {
        typeTwo_sucai.value = ru_sucai.value[i].type;
        ru_sucai.value[i].checked = true;
        sucai_params.value.materialType = ru_sucai.value[i].type;
        sucai_params.value.memberId = userList.value.memberId;
        get_sucaiList();
      } else {
        ru_sucai.value[i].checked = false;
      }
    }
  }
};
//右侧 收藏
let ru_soucang = ref([
  {
    title: "收藏作品",
    checked: true,
    number: 0,
    type: "zp",
  },
  {
    title: "收藏视频",
    checked: false,
    number: 0,
    type: "VIDEO",
  },
  {
    title: "收藏音乐",
    checked: false,
    number: 0,
    type: "MUSIC",
  },
  {
    title: "收藏图片",
    checked: false,
    number: 0,
    type: "IMAGE",
  },
]);
let ru_soucang_click = function (index, type) {
  for (let i = 0; i < ru_soucang.value.length; i++) {
    if (i === index) {
      ru_soucang.value[i].checked = true;
      console.log(i);
      if (i === 0) {
        // 收藏的作品列表接口
        get_soucang_sucai_list1(type);
        console.log("作品");
      } else if (i >= 1 && i <= 3) {
        get_soucang_sucai_list(ru_soucang.value[i].type);
      }
    } else {
      ru_soucang.value[i].checked = false;
    }
  }
};
//素材数据展示
let sucai_music_list = ref([]);
let sucai_video_list = ref([]);
let sucai_image_list = ref([]);
// 素材跳转详情页
let getDetailPage = function (url, index) {
  router.push({
    path: url,
    query: {
      id: index.id,
    },
  });
};
// 获取素材的数量
// let get_sucai_number = function () {
//   Axios(
//     "get",
//     "/fodder/manage/",
//     {  memberId: id.value },
//     false,
//     function (res) {

//     }
//   );
// };
// get_sucai_number()
// 右侧公共分页 ********************
let sucai_params = ref({
  status: 1, // 审核通过
  memberId: userList.value.memberId, //会员ID
  isOnline: 0, // 0 上架
  materialType: "", // 素材的类型 [已点击获取]
  pageNum: 1,
  pageSize: 6,
  orderByColumn: "createTime",
  isAsc: "desc",
});
let get_sucaiList = function () {
  sucai_params.value.pageNum = page3.value.pageNum;
  Axios("GET", "/fodder/front/list", sucai_params.value, false, function (res) {
    if (typeTwo_sucai.value == "VIDEO") {
      sucai_video_list.value = res.data.rows;
    }
    if (typeTwo_sucai.value == "IMAGE") {
      sucai_image_list.value = res.data.rows;
    }
    if (typeTwo_sucai.value == "MUSIC") {
      sucai_music_list.value = res.data.rows;
    }
    page3.value.total = res.data.total;
  });
};
// 获取素材的数量
let sucai_params1 = ref({
  status: 1, // 审核通过
  memberId: "", //会员ID
  isOnline: 0, // 0 上架
  orderByColumn: "createTime",
  isAsc: "desc",
  materialType: "VIDEO", // 素材的类型 [已点击获取]
});
let sucai_params2 = ref({
  status: 1, // 审核通过
  memberId: "", //会员ID
  isOnline: 0, // 0 上架
  orderByColumn: "createTime",
  isAsc: "desc",
  materialType: "MUSIC", // 素材的类型 [已点击获取]
});
let sucai_params3 = ref({
  status: 1, // 审核通过
  memberId: "",
  isOnline: 0, // 0 上架
  orderByColumn: "createTime",
  isAsc: "desc",
  materialType: "IMAGE", // 素材的类型 [已点击获取]
});
let right_urlList1 = ref(0);
const getList = () => {
  Axios(
    "GET",
    "/fodder/front/list",
    sucai_params1.value,
    false,
    function (res) {
      ru_sucai.value[0].number = res.data.total;
      right_urlList1.value += Number(res.data.total);
      right_urlList.value[1].number = right_urlList1.value; // 素材总数量
    }
  );
  Axios(
    "GET",
    "/fodder/front/list",
    sucai_params2.value,
    false,
    function (res) {
      ru_sucai.value[1].number = res.data.total;
      right_urlList1.value += Number(res.data.total);
      right_urlList.value[1].number = right_urlList1.value; // 素材总数量
    }
  );
  Axios(
    "GET",
    "/fodder/front/list",
    sucai_params3.value,
    false,
    function (res) {
      ru_sucai.value[2].number = res.data.total;
      right_urlList1.value += Number(res.data.total);
      right_urlList.value[1].number = right_urlList1.value; // 素材总数量
      loading.value.close();
    }
  );
};
let page3 = ref({
  pageNum: 1, //页数
  total: 0, // 总数
  pageSize: 6,
});
let isType = function () {
  if (typeOne.value == 0) {
    getListZUOPING();
  }
  if (typeOne.value == 1) {
    get_sucaiList();
  }
  if (typeOne.value == 2) {
    ru_soucang.value.forEach((e, index) => {
      if (e.checked) {
        ru_soucang_click(index);
      }
    });
  }
};
const sizeChange2 = (val) => {
  console.log("val", val);
  page3.value.pageNum = val;
  isType();
};
const currentChange2 = (val) => {
  console.log("val", val);

  page3.value.pageNum = val;
  isType();
};
const prevClick2 = (val) => {
  console.log("val", val);

  page3.value.pageNum = val;
  isType();
};

const loading = ref(null);
watch(
  () => router.currentRoute.value.params,
  async (params) => {
    console.log(router.currentRoute.value);
    id.value = router.currentRoute.value.query.id;
    let url = router.currentRoute.value.href;
    let start = url.indexOf("/");
    let length = url.indexOf("?") - start - 1;
    let targetString = url.substr(start + 1, length);
    if (
      id.value &&
      id.value.length < 10 &&
      url.substr(start + 1, length) == "ShadowComposerHomepage"
    ) {
      loading.value = ElLoading.service({
        lock: true,
        text: "Loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      await nextTick();
      right_urlList1.value = 0;
      SC_VIDEO_LIST1.value = [];
      sucai_music_list.value = [];
      sucai_video_list.value = [];
      sucai_image_list.value = [];
      sucai_params1.value.memberId = router.currentRoute.value.query.id;
      sucai_params2.value.memberId = router.currentRoute.value.query.id;
      sucai_params3.value.memberId = router.currentRoute.value.query.id;

      await getuserMassage();
      await getListZUOPING();
      await getmy_count();
      await getList();
    }
    // console.log("Params changed:", params);
  },
  { immediate: true }
);
const getmy_count = () => {
  Axios(
    "GET",
    `/fodder/collect/my-count/${router.currentRoute.value.query.id}`,
    false,
    false,
    function (res) {
      if (res.data.data) {
        ru_soucang.value[1].number = res.data.data.videoCount;
        ru_soucang.value[2].number = res.data.data.musicCount;
        ru_soucang.value[3].number = res.data.data.imageCount;
        ru_soucang_click(0, true);
      } else {
        ru_soucang.value[1].number = 0;
        ru_soucang.value[2].number = 0;
        ru_soucang.value[3].number = 0;
        ru_soucang_click(0, true);
      }
    }
  );
};
const SC_VIDEO_LIST1 = ref([]);
let getUserList = {
  // pageNum: page.value.pageNum,
  pageSize: 6,
  pageIndex: page3.value.pageNum,
  status: 0,
};
// 访问作品
const getListZUOPING = function (index = 0) {
  getUserList.pageIndex = page3.value.pageNum;
  index == 0 ? delete getUserList.sort : "";
  index == 1 ? (getUserList.sort = "id") : "";
  index == 2 ? (getUserList.sort = "plays") : "";
  // loading.value = ElLoading.service({
  //   lock: true,
  //   text: "Loading",
  //   background: "rgba(0, 0, 0, 0.7)",
  // });
  Axios(
    "post",
    `/material/material/work/listByUserId?userId=${router.currentRoute.value.query.id}`,
    getUserList,
    false,
    function (res) {
      SC_VIDEO_LIST1.value = [];
      SC_VIDEO_LIST1.value = res.data.data.records;
      // page.value.pageNum = res.data.pages //总页数
      page3.value.total = res.data.data.total;
      // console.log("page2page2page2page2page2", page3.value);
      right_urlList.value[0].number = res.data.data.total;
      ru_zuoping.value[0].number = res.data.data.total;
      ru_zuoping.value[1].number = res.data.data.total;
      ru_zuoping.value[2].number = res.data.data.total;

      // loading.value.close();
    }
  );
};
const collectIds = ref([]);
const getCollects = async () => {
  await Axios("get", "/fodder/collect/collect-ids", {}, false, (res) => {
    collectIds.value = res.data.data;
  });
};
getCollects();
// getListZUOPING();
</script>

<style lang="less" scoped>
.zwsj {
  width: 50%;
  margin: 0 auto;
  display: block;
}

.bg_img {
  height: 3.5rem;
  width: 100%;
  overflow: hidden;
}

.bg_img::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 56px;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.6));
  z-index: 1;
}

.body {
  display: flex;
  justify-content: flex-start;
  width: 12.8rem;
  margin: 0 auto;
  position: relative;
}

.body_left {
  width: 3.02rem;
  border-radius: 0.12rem;
  background: #fff;
  position: relative;
  top: -0.53rem;
}

.body_left_img {
  width: 0.8rem;
  border: 0.08rem solid #ffffff;
  display: block;
  margin: 0 auto;
  border-radius: 50%;

  /* padding-bottom:0.24rem; */
}

.body_left_userList,
.body_video_left_userMessage {
  display: flex;
  justify-content: center;
  align-items: center;
}

.body_video_left_userMessage>div {
  width: 33%;
}

.body_left_userList>span {
  margin-right: 0.06rem;
  font-size: 0.14rem;
  color: #000000;
}

.body_left_userList>img {
  width: 0.16rem;
  margin-right: 0.06rem;
}

.bvlu_number {
  display: block;
  text-align: center;
  color: #000000;
  font-size: 0.2rem;
}

.bvlu_title {
  display: block;
  color: #86909c;
  font-size: 0.12rem;
  text-align: center;
  margin-top: 0.08rem;
}

.body_video_left_userMessage {
  margin-top: 0.18rem;
}

.body_video_left_userMessage>view {
  width: 33.33%;
}

.body_video_left_message_title {
  margin-top: 0.08rem;
  font-size: 0.12rem;
  text-align: center;
  padding: 0 0.16rem;
  display: block;
  color: #86909c;
}

.body_video_left_button {
  display: flex;
  justify-content: center;
}

.body_video_left_button>button {
  padding: 0.08rem 0;
  width: 0.88rem;
  border-radius: 0.08rem;
  text-align: center;
  font-size: 0.14rem;
  margin-top: 0.16rem;
}

.bvlb_gz {
  margin-right: 0.2rem;
  border: 0.01rem solid #86909c;
  background: #fff;
  color: #333333;
}

.bvlb_lxhz {
  background: #c01a26;
  color: #fff;
  border: 0.01rem solid #c01a26;
}

.body_video_left_location {
  display: block;
  margin-top: 0.2rem;
  padding: 0.2rem 0.17rem;
  border-top: 0.01rem solid #e5e6eb;
  border-bottom: 0.01rem solid #e5e6eb;
  color: #333333;
  font-size: 0.14rem;
}

.body_video_left_visit {
  padding: 0 0.12rem;
  margin-top: 0.2rem;
}

.bvlv_title {
  font-size: 0.16rem;
  color: #000000;
  margin-top: 0.2rem;
  margin-left: 0.16rem;
}

.bvlv_imgList {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.bvlv_imgList>div {
  width: 33.33%;
  margin-top: 0.2rem;
}

.bvlv_imgList>div>img {
  width: 0.5rem;
  display: block;
  margin: 0 auto;
  margin-bottom: 0.04rem;
}

.bvlv_imgList_title {
  font-size: 0.12rem;
  color: #333333;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  width: 50%;
  margin: 0 auto;
}

.bvlv_imgList_time {
  color: #86909c;
  font-size: 0.12rem;
  text-align: center;
  display: block;
}

.body_right {
  position: relative;
  top: -0.53rem;
}

.body_right_topList {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  position: relative;
  top: -0.16rem;
}

.body_right_topList>div {
  padding: 0.16rem;

  font-size: 0.14rem;
}

.body_right_topList_t {
  border-bottom: 0.02rem solid #fff;
  color: #fff;
}

.body_right_topList_f {
  color: #fff;
  border-bottom: 0.02rem solid rgba(0, 0, 0, 0);
}

.body_right_topList>div>span {
  margin-left: 0.04rem;
}

.accessListPopup {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.2);
  -webkit-backdrop-filter: blur(2px);
  backdrop-filter: blur(0.08rem);
  box-shadow: inset 0 00.06rem rgba(255, 255, 255, 0.2);
}

.aLP_center {
  display: block;
  margin: 0 auto;
  margin-top: 1.14rem;
  border-radius: 0.12rem;
  background: #fff;
  width: 6rem;
  height: calc(80vh);
  padding: 0.17rem 0.24rem 0.8rem;
  position: relative;
}

.aLP_center_top {
  display: flex;
  justify-content: space-between;
}

.aLP_center_top>div {
  font-size: 0.16rem;
  color: #333333;
}

.aLP_center_top>img {
  width: 0.2rem;
}

.wVC_list {
  display: flex;
  justify-content: space-between;
  margin-top: 0.2rem;
}

.wVC_list_l_userImg {
  width: 0.5rem;
  border-radius: 50%;
  margin-right: 0.12rem;
}

.wVC_list_l {
  display: flex;
  justify-content: flex-start;
}

.wVC_list_l_Title {
  display: flex;
  flex-direction: column;
}

.wVC_list_l_Title>div {
  display: flex;
  /* flex-direction: row-reverse; */
  align-items: center;
}

.wVC_list_l_T_T_name {
  font-size: 0.16rem;
  color: #333333;
  margin-right: 0.08rem;
}

.wVC_list_l_T_T_time {
  color: #86909c;
  font-size: 0.12rem;
}

.wVC_list_l_T_B {
  margin-top: 0.06rem;
}

.wVC_list_l_T_B_rz {
  color: #015243;
  background: #e1fefc;
  border-radius: 0.1rem;
  font-size: 0.12rem;
  padding: 0.02rem 0.16rem 0.02rem 0.04rem;
  display: flex;
  align-items: center;
}

.wVC_list_l_T_B_rz>img {
  width: 0.13rem;
  margin-right: 0.09rem;
}

.wVC_list_r {
  display: flex;
  align-items: center;
}

.wVC_list_r>button {
  padding: 0.06rem 0.16rem;
  font-size: 0.12rem;
  border-radius: 0.04rem;
}

.wVC_list_r_lx {
  border: 0.01rem solid #333333;
  color: #333333;
  margin-right: 0.16rem;
}

.wVC_list_r_gz {
  background: #c01a26;
  color: #ffffff;
  border: 0rem solid #333333;
}

.el-pagination {
  justify-content: center;
}

/deep/.el-pager li {
  padding: 0.06rem;
  margin: 0 0.03rem;
}

/deep/.el-pager li.is-active {
  color: #fff;
  background: #c01a26;
}

/deep/.el-pager li:hover {
  color: #fff;
  background: #c01a26;
}

.zf_body {
  border-radius: 0.12rem;
}

.zf_body_top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.2rem;
}

.zf_body_top>span {
  color: #333333;
  font-size: 0.16rem;
}

.zf_body_top>img {
  width: 0.2rem;
}

.zf_body_title {
  color: #86909c;
  font-size: 0.14rem;
  text-align: center;
  margin-bottom: 0.12rem;
}

.zf_b_M {
  display: flex;
  justify-content: center;
  align-items: baseline;
}

.zf_b_M_title {
  font-size: 0.14rem;
  color: #000000;
}

.zf_b_M_number {
  font-size: 0.24rem;
  color: #c01a26;
}

.zf_b_M_n_icon {
  font-size: 0.14rem;
}

.zf_fs_body {
  margin-top: 0.2rem;
}

.zf_fs_title {
  color: #000000;
  font-size: 0.14rem;
  margin-bottom: 0.12rem;
}

.zf_fs_list {
  display: flex;
}

.zf_fs_list>div {
  position: relative;
  border-radius: 0.04rem;
  border: 1px solid #e5e6eb;
  padding: 0.08rem 0;
  width: 1.1rem;
  margin-right: 0.12rem;
  display: flex;
  justify-content: center;
}

.zf_fs_logo {
  width: 0.24rem;
  margin-right: 0.04rem;
}

.zf_fs_icon {
  width: 0.25rem;
  position: absolute;
  right: 0;
  bottom: 0;
}

.zf_fs_b {
  display: flex;
  justify-content: center;
}

.zf_fs_b>div {
  padding: 0.08rem 0.3rem;
  font-size: 0.14rem;
  border-radius: 0.08rem;
  border: 0.01rem solid #333333;
}

.zf_fs_b_qx {
  color: #333333;
}

.zf_fs_b>.zf_fs_b_qd {
  color: #ffffff;
  border: 0.01rem solid #c01a26;
  background: #c01a26;
  margin-left: 0.2rem;
}

.zf_fs_body {
  margin-bottom: 0.2rem;
}

/deep/.el-dialog__header {
  padding: 0 !important;
}

.brt_list {
  display: flex;
}

.top_click_list>div {
  padding: 0.08rem 0.16rem;
  border-radius: 0.08rem;
  font-size: 0.14rem;
  margin-right: 0.2rem;
}

.top_click_listT {
  border: 0.01rem solid #c01a26;
}

.top_click_listF {
  border: 0.01rem solid rgba(0, 0, 0, 0);
}

.modifyCoverUpload {
  line-height: 1.46rem;
  font-size: 0.14rem;
  text-align: center;
  color: #fff;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  border-radius: 12px;
}

.modifyCoverBnt {
  width: 0.88rem;
  height: 0.37rem;
  margin: 0 auto;
  background: #c01a26;
  color: #fff;
  text-align: center;
  line-height: 0.37rem;
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  opacity: 1;
}

/deep/.avatar-uploader .avatar {
  width: 100%;
  height: 178px;
  display: block;
}

/deep/.avatar-uploader .el-upload {
  border: 1px dashed var(--el-border-color);
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: var(--el-transition-duration-fast);
  width: 100%;
}

/deep/.avatar-uploader .el-upload:hover {
  border-color: var(--el-color-primary);
}

/deep/.el-icon.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100%;
  height: 178px;
  text-align: center;
  background: #f5f5f5;
}

.ghbj {
  z-index: 3;
  padding: 0.09rem 0.12rem;
  border-radius: 0.08rem;
  background: rgba(255, 255, 255, 0.2);
  font-size: 0.12rem;
  color: #ffffff;
  display: block;
  position: relative;
  top: -0.08rem;
  cursor: pointer;
}

.ghbj>img {
  width: 0.16rem;
}
</style>
